import TrialPage2 from './containers/SampleTrial2Container'

export default store => {
  return {
    path: 'sample-trial-2-pdf',
    exact: true,
    getComponent(nextState, cb) {
      require.ensure([], () => {
        cb(null, TrialPage2, 'articles')
      })
    },
  }
}
